import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Tabs, Button, Card } from 'antd';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import UIList from './UI.List';

const css = require('./index.scss');
const TabPane = Tabs.TabPane;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
interface IState {
    currentTab: string;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState, any> {
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            currentTab: '1',
            fresh: '',
            ban: '',
            accept: '',
            creat: ''
        };
    }
    //批量接受
    onAcceptHandler = () => {
        this.setState({
            accept: JSString.randomABC(8)
        });
    }
    //批量拒绝
    onBanHandler = () => {
        this.setState({
            ban: JSString.randomABC(8)
        });
    }
    //批量开票
    onCreatHandler = () => {
        this.setState({
            create: JSString.randomABC(8)
        });
    }
    //刷新
    onRefresh = () => {
        this.setState({
            fresh: JSString.randomABC(8)
        });
    }
    componentDidMount() {

    }
    render() {
        const operations = (
            <div>
                {
                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchMakeInvoice) && 
                    <Button type="primary" onClick={this.onCreatHandler}>
                        批量开票
                    </Button>
                }
                {
                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchAccept) && 
                    <Button type="primary" onClick={this.onAcceptHandler} className="ml10">
                        批量接受
                    </Button>
                }
                {
                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchRefuse) && 
                    <Button type="default" onClick={this.onBanHandler} className="ml10">
                        批量拒绝
                    </Button>
                }
                <Button type="default" icon="sync" onClick={this.onRefresh} className="ml10">
                    刷新
                </Button>
            </div>
        );

        return (
            <Card>
                <Tabs
                    defaultActiveKey={this.state.currentTab}
                    tabBarExtraContent={operations}
                    activeKey={"" + this.state.currentTab}
                >
                    <TabPane tab="销项结算单列表" key='1'>
                        <UIList
                            ban={this.state.ban}
                            accept={this.state.accept}
                            fresh={this.state.fresh}
                            create={this.state.create}
                        />
                    </TabPane>
                </Tabs>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.Components.tsx